export default __webpack_public_path__ + "static/media/player.8541ed6b.svg";